<template>
  <div class="row">

    <div class="col-12">

      <card>
        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <h4 class="card-title">Session List</h4>
          <div class="d-flex justify-content-start">

            <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['sessions/create'])"
                         :to="'/sessions/create'"
                         class="btn btn-info btn-wd">
              Add New
              <span class="btn-label">
                      <i class="fa fa-plus"></i>
                  </span>
            </router-link>
          </div>

        </div>

        <!--    filters    -->
        <div class="row col-12 mb-2">
          <div class="col-md-4 col-sm-4">
            <fg-select
              size="large"
              filterable
              clearable
              placeholder="Select Edition"
              :input-classes="'select-default'"
              :list="filterBuilders.forums"
              :listItemLabel="'name'"
              :listItemValue="'id'"
              v-model="filters.forum_id">
            </fg-select>
          </div>

          <div class="col-md-2 col-sm-4">
            <l-button class="mr-lg-1" @click="applyFilter()" type="info">Filter Result</l-button>
          </div>
        </div>
        <!--  end  filters    -->

        <div>
          <general-data-table
            ref="table"
            :method="'POST'"
            :row-key="'id'"
            :key="componentKey"
            :api-url="'sessions/index'">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :align="column.align"
                             :sortable="column.sortable"
                             :prop="column.value"
                             :label="column.label">
            </el-table-column>

            <el-table-column
              :min-width="120"
              align="center"
              :fixed="'right'"
              label="Active">
              <template slot-scope="props">

                <l-switch v-if="$store.getters['auth/haveOneOfPermissions'](['sessions/change-active-status'])"
                          v-model="props.row.is_active" @input="handleActiveStatus(props.row)">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </l-switch>

              </template>
            </el-table-column>

            <el-table-column
              :min-width="120"
              :fixed="'right'"
              align="center"
              label="Actions">
              <template slot-scope="scope">

                <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['recordings/index'])"
                             v-tooltip.top-center="'Manage Recordings'"
                             class="btn-primary btn-simple btn-link"
                             :to="'/recordings/list/'+scope.row.id">
                  <i class="fa fa-video"></i></router-link>
                <router-link v-if="$store.getters['auth/haveOneOfPermissions'](['sessions/documents/index'])"
                             v-tooltip.top-center="'Manage Documents'"
                             class="btn-success btn-simple btn-link"
                             :to="'/sessions/documents/list/'+scope.row.id">
                  <i class="fa fa-file"></i></router-link>

                
  <button v-if="$store.getters['auth/haveOneOfPermissions'](['sessions/update'])"
          v-tooltip.top-center="'Edit'"
          class="btn-warning btn-simple btn-link"
          @click="handleEdit(scope.row.id)">
    <i class="fa fa-edit"></i>
  </button>


  <a v-if="$store.getters['auth/haveOneOfPermissions'](['sessions/delete'])"
                   v-tooltip.top-center="'Delete'"
                   class="btn-danger btn-simple btn-link"
                   @click="openDeleteModal(scope.row.id)"><i class="fa fa-times"></i></a>
              </template>
            </el-table-column>

          </general-data-table>
        </div>

        <delete-modal :visible="deleteModalVisibility"
                     :message="'Are you sure you want to delete this session?'"
                     @close="closeDeleteModal()"
                     @confirm="confirmDeleteModal()">
        </delete-modal>

      </card>

    </div>

  </div>
</template>
<script>
import {TableColumn} from 'element-ui'
import {DeleteModal as DeleteModal, NewPagination as NLPagination, Switch as LSwitch} from '@/components'
import GeneralDataTable from "@/components/GeneralDataTable";
import FgSelect from "@/components/Inputs/formGroupSelect";
import ExportModal from '@/components/ExportModal/ExportModal.vue';
import Swal from 'sweetalert2'

export default {
  components: {
    NLPagination,
    DeleteModal,
    [TableColumn.name]: TableColumn,
    LSwitch,
    GeneralDataTable,
    FgSelect,
    ExportModal
  },

  data() {
    return {
      tableColumns: [
        {label: 'Name', value: 'name', minWidth: '200', align: 'center'},
        {label: 'Edition', value: 'forum.name', minWidth: '200', align: 'center'},
        {label: 'URL', value: 'url', minWidth: '200', align: 'center'},
      ],
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false
      },
      componentKey: 0,
      filterBuilders: {
        forums: []
      },
      deleteModalVisibility: false,
      toDeleteId: undefined,
      componentKey: 0,
      filterBuilders: {
        forums: []
      },
      filters: {
        forum_id: null,
        type: 'normal'
      },
    }
  },
  async mounted() {
    let response = await this.axios.post("sessions/builder");
    this.filterBuilders.forums = response.data.forums;
  },
  methods: {
    handleEdit(sessionId) {

    this.$router.push(`/sessions/edit/${sessionId}`);
  },
    handleActiveStatus(row) {
      let data = {
        'is_active': row.is_active,
      }
      this.axios.post("sessions/change-active-status/" + row.id, data).then((response) => {
        this.$notify({
          message: "Session updated successfully",
          timeout: 1000,
          type: 'success'
        });
      }).catch((error) => {
        console.log(error)
      })
    },

    deleteSession(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete(`sessions/delete/${id}`).then((response) => {
            this.$notify({
              message: "Session Deleted Successfully",
              timeout: 1000,
              type: 'success'
            });
            this.getList();
          }).catch((error) => {
            let errorMessage = "Error deleting session";
            if (error.response?.data?.message) {
              errorMessage = error.response.data.message;
            }
            this.$notify({
              message: errorMessage,
              timeout: 2000,
              type: 'danger'
            });
          });
        }
      });
    },

    openDeleteModal(id) {
      this.deleteModalVisibility = true;
      this.toDeleteId = id;
    },

    closeDeleteModal() {
      this.deleteModalVisibility = false;
    },

    confirmDeleteModal() {
      let data = {
        'id': this.toDeleteId,
      }
      this.axios.delete("sessions/delete", {headers: {}, data}).then((response) => {
        this.$notify({
          message: "Session deleted successfully",
          timeout: 1000,
          type: 'success'
        });

        this.$refs.table.getData("updateData");
      }).catch((error) => {
        this.$notify({
          message: error.response?.data?.message || "Error deleting session",
          timeout: 2000,
          type: 'danger'
        })
      }).finally(() => {
        this.closeDeleteModal();
        this.toDeleteId = undefined;
      });
    },

    openModal(name) {
      this.modals[name] = true
    },
    closeModal(name) {
      this.modals[name] = false
    },
    currentForumClass(row, rowIndex) {
      if (rowIndex === 1) {
        return 'success-row';
      }
    },
    applyFilter() {
      this.$refs.table.filters = {...this.filters};
      this.$refs.table.getData("updateData");
    },
  },

}
</script>
